/**
 * URL Utils
 */
import { Params } from '@angular/router';
import { LeadsFilters, NullablePartial } from '../services/application.model';
import { NoValue } from '@tribeauto/ngx-mobilite-material';
import { QueryParamsEnum } from '../../shared/pages/callback/callback.model';

export type URLParamValue = string | number | undefined;

/**
 * Join all urls path into one URL using '/'
 *
 * @param urls
 */
export const urlJoin = (...urls: string[]): string => urls.join('/');

/**
 * Join all map items into a UrlParams string
 *
 * @param map
 */
export const toPathParams = (map: Map<string, URLParamValue>): string =>
  [...map.entries()]
    .filter(([_key, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

/**
 * Build a full url using url and params map
 *
 * @param url
 * @param map
 */
export const urlBuildWithParams = (url: string, map: Map<string, URLParamValue>): string =>
  [url, toPathParams(map)].filter(item => !!item).join('?');

export const getParamsFromLeadsFilters = (leadsFilters: NullablePartial<LeadsFilters> | NoValue): Params => {
  const params: Params = {};
  if (leadsFilters) {
    if (leadsFilters.index) {
      params[QueryParamsEnum.INDEX] = leadsFilters.index.toString();
    }
    if (leadsFilters.pos) {
      params[QueryParamsEnum.POS] = leadsFilters.pos;
    }
    if (leadsFilters.cckNumber) {
      params[QueryParamsEnum.CCK_NUMBER] = leadsFilters.cckNumber;
    }
    if (leadsFilters.clientName) {
      params[QueryParamsEnum.CLIENT_NAME] = leadsFilters.clientName;
    }
  }
  return params;
};
